import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import EmailImportBox from "./components/EmailImportBox";
import EmailResults from "./components/EmailResults";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "./firebase"; // adjust path
import { getAuth } from "firebase/auth";
import Cookies from "js-cookie";
import { useRef } from "react";
import Testimonials from "./components/Testimonials";
import EmailFiles from "./components/EmailFiles";
import HeroInputAnimation from "./components/HeroInputAnimation";
import axios from "axios";
import { doc, getDoc } from "firebase/firestore";
import { db } from "./firebase";
import { downloadFile } from "./utils/downloadFile";

function Home() {
    const location = useLocation();
    const [showRegisteredMessage, setShowRegisteredMessage] = useState(false);
    const [showLogoutMessage, setShowLogoutMessage] = useState(false);
    const [showLoginMessage, setShowLoginMessage] = useState(false);
    const [result, setResult] = useState(null);
    const [user] = useAuthState(auth);
    const [showResults, setShowResults] = useState(false);
    const [showFiles, setShowFiles] = useState(false);
    const [scrubCount, setScrubCount] = useState(0); // to track user actions
    const [pendingInput, setPendingInput] = useState("");
    const [uploadedFileName, setUploadedFileName] = useState(null);
    const [scrubFile, setScrubFile] = useState(null);
    const [uploadedFile, setUploadedFile] = useState(null);
    const [randomString, setRandomString] = useState('');
    const [resultUrl, setResultUrl] = useState(null);
    const [statusUrl, setStatusUrl] = useState(null);
    const [taskId, setTaskId] = useState(null);
    const [totalEmails, setTotalEmails] = useState(null);
    const [progress, setProgress] = useState(0);
    const [files, setFiles] = useState([]);
    const [userData, setUserData] = useState(null);
    const [scrubStatus, setScrubStatus] = useState(null);
    const [progressResults, setProgressResults] = useState(null);

    const mockFiles = [
        {
            name: "verified_emails.csv",
            emailCount: 150,
            downloadUrl: "/downloads/verified_emails.csv",
        },
        {
            name: "invalid_emails.csv",
            emailCount: 38,
            downloadUrl: "/downloads/invalid_emails.csv",
        },
    ];

    const resetResults = () => {
        setResult(null);
        setShowFiles(false);
        setFiles([]);
        setShowResults(false)
        setProgress(0);
    };

    const resetScrubData = () => {
        setPendingInput("");
        setUploadedFile(null);
        setUploadedFileName("");
        setResult(null);
        setShowResults(false);
        setShowFiles(false);
        setTaskId(null);
        setProgress(null);
        setTotalEmails(0);
    };

    const fetchUserData = async () => {
        const auth = getAuth();
        const user = auth.currentUser;
        if (!user) return null;

        const userRef = doc(db, "users", user.uid);
        const userSnap = await getDoc(userRef);
        if (userSnap.exists()) {
            const data = userSnap.data();
            setUserData(data);
            return data;
        }
        return null;
    };

    const generateRandomString = () => {
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let result = '';
        const length = 6;
        for (let i = 0; i < length; i++) {
            const randomIndex = Math.floor(Math.random() * characters.length);
            result += characters[randomIndex];
        }
        setRandomString(result);
    };

    const HeroSectionFull = () => (
        <section className="hero-email-section">
            <div className="hero-email-content">
                <h1>The most accurate email <br></br> verification platform</h1>
                <p>
                    <strong>Stop losing money</strong> by sending your emails into the void. <br />
                    Join the <span className="highlight">200,000+ businesses</span> that rely on us to verify their emails <strong>before they hit Send.</strong>
                </p>

                <HeroInputAnimation/>

                <div className="sub-note">Includes 300 free credits • <span>No credit card required!</span></div>

                <div className="compliance-icons">
                    <span>🛡️ GDPR COMPLIANT</span>
                    <span>🇪🇺 EU DATA SERVERS</span>
                    <span>📁 99% DELIVERABILITY GUARANTEE</span>
                    <span>💳 POWERED BY STRIPE</span>
                </div>
            </div>
        </section>
    );

    const HeroSection = () => (
        <section className="hero-email-section">
            <div className="hero-email-content">
                <h1>The most accurate email verification platform</h1>
                <p>
                    <strong>Stop losing money</strong> by sending your emails into the void. <br />
                    Join the <span className="highlight">200,000+ businesses</span> that rely on us to verify their emails <strong>before they hit Send.</strong>
                </p>
                <div className="compliance-icons">
                    <span>🛡️ GDPR COMPLIANT</span>
                    <span>🌍 EU DATA SERVERS</span>
                    <span>💳 99% DELIVERABILITY GUARANTEE</span>
                    <span>🌍 POWERED BY STRIPE</span>
                </div>
            </div>
        </section>
    );

    const handleScrub = async () => {
        if (!pendingInput) return;

        setShowResults(false);
        setShowFiles(false);



        //Decide on the filename
        let fileToUpload = null;
        let fileName = uploadedFileName;
        let total = 0;

        if (uploadedFile) {
            //User uploaded a file — send it as-is
            fileToUpload = uploadedFile;

            const rawText = await uploadedFile.text();
            const emails = rawText
                .split(/[\n,]+/)
                .map(e => e.trim())
                .filter(e => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e));
            total = emails.length;
        } else {
            //User manually entered emails — create CSV
            const rawLines = pendingInput.split(/[\n,]+/).map(line => line.trim());
            const emails = rawLines.filter(email => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email));
            total = emails.length;

            const now = new Date();
            const datetimeString = now
                .toISOString()
                .replace(/[-:]/g, "")
                .replace(/\..+/, "");
            fileName = `${datetimeString}_scrub_input.csv`;

            const csvContent = [...emails].join("\n");
            const csvBlob = new Blob([csvContent], { type: "text/csv" });
            fileToUpload = new File([csvBlob], fileName, { type: "text/csv" });
        }

        generateRandomString();
        //Upload to backend
        const formData = new FormData();
        formData.append("file", fileToUpload);

        ////////////////////////
        ////////////////////////
        ////////////////////////
        const auth = getAuth();
        const user = auth.currentUser;

        //Fetch userData when user is logged in
        const userInfo = await fetchUserData();

        if (!userInfo) {
            alert("Could not load user data.");
            return;
        }

        try {
            const idToken = await user.getIdToken();

            // const response = await fetch("http://localhost:5000/verifier/verify", {
            //     method: "POST",
            //     body: formData,
            // });
            const response = await axios.post(process.env.REACT_APP_API_URL+"/verifier/verify", formData, {
                headers: {
                    Authorization: `Bearer ${idToken}`,
                    "Content-Type": "multipart/form-data",
                },
            });

            if (response.status === 200) {
                setScrubStatus("in_progress"); // You’re tracking status separately
                setShowResults(true); //Ensure this is here

                const { result_url, status_url, task_id, total_emails } = response.data;
                setTaskId(task_id);
                setStatusUrl(status_url);
                setTotalEmails(total_emails);
                setResultUrl(result_url);
                setShowResults(true);
                setShowFiles(false);
                setScrubCount(prev => prev + 1);

                setProgressResults({
                    name: fileName,
                    total: total_emails,
                    date: new Date().toLocaleDateString(),
                });
                console.log(process.env.REACT_APP_VERIFIER_URL)

                //Poll status
                const intervalId = setInterval(async () => {
                    try {
                        const statusRes = await axios.get(process.env.REACT_APP_API_URL+`/status/${task_id}`, {
                            headers: { Authorization: `Bearer ${idToken}` },
                        });

                        const { status, completed, total } = statusRes.data;
                        const percent = Math.floor((completed / total) * 100);
                        setProgress(percent);

                        // IF COMPLETED SHOW RESULTS AND SHOW DOWNLOADABLE FILES
                        if (status === "completed") {
                            clearInterval(intervalId);
                            setScrubStatus("completed"); // Mark complete

                            const {
                                valid_emails_count,
                                invalid_emails_count,
                                total_emails_count,
                                xlsx_path,
                                csv_path,
                            } = statusRes.data;
                            const finalXLSXUrl = process.env.REACT_APP_VERIFIER_URL+"/"+xlsx_path;
                            const finalCSVUrl = process.env.REACT_APP_VERIFIER_URL+"/"+csv_path;
                            console.log(xlsx_path);
                            console.log(csv_path);
                            console.log(finalXLSXUrl);
                            console.log(finalCSVUrl);
                            console.log(process.env.REACT_APP_VERIFIER_URL)

                            clearInterval(intervalId);

                            const stats = {
                                deliverable: Math.floor(valid_emails_count),
                                undeliverable: Math.floor(invalid_emails_count),
                                // risky: Math.floor(total * 0.2),
                                // unknown: Math.floor(total * 0.05),
                                // duplicate: total - (
                                //     Math.floor(total * 0.4) +
                                //     Math.floor(total * 0.3) +
                                //     Math.floor(total * 0.2) +
                                //     Math.floor(total * 0.05)
                                // ),
                            };

                            setResult({
                                name: fileName,
                                total: total_emails_count,
                                date: new Date().toLocaleDateString(),
                                stats,
                            });

                            // Delay 3 seconds then show files
                            setTimeout(() => {
                                setShowFiles(true);
                                setFiles([
                                    {
                                        name: fileName,
                                        emailCount: valid_emails_count,
                                        downloadUrlXLSX: () => downloadFile(finalXLSXUrl, idToken, fileName + ".xlsx"),
                                        downloadUrlCSV: () => downloadFile(finalCSVUrl, idToken, fileName + ".csv"),
                                    },
                                ]);
                            }, 1000);
                        }
                    } catch (err) {
                        console.error("Status check failed", err);
                    }
                }, 1000);
            }

            // const data = await response.json();
            //
            // if (response.ok && data.message === "OK!") {
            //     //Only show results if upload was successful
            //
            //     const stats = {
            //         deliverable: Math.floor(total * 0.04),
            //         undeliverable: Math.floor(total * 0.58),
            //         risky: Math.floor(total * 0.29),
            //         unknown: Math.floor(total * 0.08),
            //         duplicate: total - (
            //             Math.floor(total * 0.04) +
            //             Math.floor(total * 0.58) +
            //             Math.floor(total * 0.29) +
            //             Math.floor(total * 0.08)
            //         ),
            //     };
            //
            //     setResult({
            //         name: fileName,
            //         total,
            //         date: new Date().toLocaleDateString(),
            //         stats,
            //     });
            //
            //     setShowResults(true);
            //     setShowFiles(false);
            //     setScrubCount(prev => prev + 1);
            // } else {
            //     console.log(data)
            //     alert("Upload failed: " + (data.message || "Unknown error"));
            // }
        } catch (err) {
            console.error("Upload error:", err.response?.data || err.message);
            alert("There was an error uploading your file. Please try again.");
        }
    };

    //TODO load analytics only if user get consent
    const consentGiven = Cookies.get("userConsent") === "accepted";

    if (consentGiven) {
        // load Google Analytics, etc.
    }

    const emailImportRef = useRef(null);
    const scrollToImportBox = () => {
        emailImportRef.current?.scrollIntoView({ behavior: "smooth" });
    };

    useEffect(() => {
        if (location.state?.registered) {
            setShowRegisteredMessage(true);

            // Clear the message after a few seconds
            const timer = setTimeout(() => setShowRegisteredMessage(false), 4000);
            return () => clearTimeout(timer);
        }
        if (location.state?.loggedOut) {
            setShowLogoutMessage(true);
            const timer = setTimeout(() => setShowLogoutMessage(false), 4000);
            return () => clearTimeout(timer);
        }
        if (location.state?.loggedIn) {
            setShowLoginMessage(true);
            const timer = setTimeout(() => setShowLoginMessage(false), 4000);
            return () => clearTimeout(timer);
        }
    }, [location.state]);

    useEffect(() => {
        // if (showResults) {
        //     const timer = setTimeout(() => setShowFiles(true), 3000);
        //     return () => clearTimeout(timer);
        // }
    }, [scrubCount]);


    return (
        <div style={{ margin: "auto",  textAlign: "center" }}>
            {showRegisteredMessage && (
                <div style={{
                    background: "#d4edda",
                    color: "#155724",
                    padding: "10px 15px",
                    borderRadius: "5px",
                    fontWeight: "bold"
                }}>
                    ✅ Successfully registered and logged in!
                </div>
            )}
            {showLogoutMessage && (
                <div style={{
                    background: "#d1ecf1",
                    color: "#0c5460",
                    padding: "10px",
                    borderRadius: "5px",
                    fontWeight: "bold"
                }}>
                    🔒 You have successfully logged out.
                </div>
            )}
            {showLoginMessage && (
                <div style={{
                    background: "#d1ecf1",
                    color: "#0c5460",
                    padding: "10px",
                    borderRadius: "5px",
                    fontWeight: "bold"
                }}>
                    ✅ Successfully logged in!
                </div>
            )}
            {user ? (
                <HeroSection/>
            ) :(
                <HeroSectionFull/>
            )}

            <div className="process-flow-section">
                <h2 className="process-flow-steps">
                    <strong> Import</strong> <span className="arrow">➜</span>
                    <strong> Verify</strong> <span className="arrow">➜</span>
                    <strong> Analyze</strong> <span className="arrow">➜</span>
                    <strong> Export</strong>
                </h2>
                <p className="process-flow-description">
                    Upload or import your list, verify your emails, analyze the results, and export them.
                    <br />
                    ScrubMail is the fastest and most accurate email checker, giving you results in minutes.
                </p>
            </div>

            {/* Divider */}
            <div style={{
                height: "4px",
                background: "linear-gradient(to right, #ccc, #eee, #ccc)",
                margin: "40px auto",
                maxWidth: "90%"
            }} />

            <section className="email-section">
                    <div className="email-section-container">
                        <div className="email-box">
                            <div ref={emailImportRef}>
                                <EmailImportBox
                                    setPendingContent={setPendingInput}
                                    setUploadedFileName={setUploadedFileName}
                                    setUploadedFile={setUploadedFile}
                                    onScrub={handleScrub}
                                    resetResults={resetResults}
                                    userCredits={userData?.balance}
                                    onModeChangeReset={resetScrubData}
                                />
                            </div>
                        </div>
                        <div className="email-box">
                            {showResults && (
                                <EmailResults
                                    result={scrubStatus === "completed" ? result : null}
                                    isInProgress={scrubStatus === "in_progress"}
                                    progress={progress}
                                    progressResults={progressResults}
                                />
                            )}                            {/*{showResults && progress < 100 && (*/}
                            {/*    <div className="progress-wrapper">*/}
                            {/*        <div className="progress-bar" style={{ width: `${progress}%` }}>*/}
                            {/*            {progress}%*/}
                            {/*        </div>*/}
                            {/*    </div>*/}
                            {/*)}*/}
                            {showFiles && result?.stats?.deliverable > 0 && <EmailFiles files={files} />}
                        </div>
                    </div>
            </section>
            <Testimonials />
        </div>
    );
}

export default Home;
